import { GameMode } from '@core/common';

import { SubscribedUser } from '../web-pushes/web-pushes.entity';

export type AuthMethod = 'steam' |
  'vk' |
  'telegram' |
  'telegram_bot' |
  'facebook' |
  'google' |
  'apple' |
  'yandex';

export type User = {
  id: number;
  nickname: string;
  level: number;
  photoUrl: string|null;
  customPhoto: string|null;
  nicknameColor: string|null;
};

export enum BetType {
  INVENTORY = 1,
  BALANCE = 2
}

export type LoggedUser = User & {
  roles: string[];
  levelExp: number;
  balanceUsd: number;
  createdAt: string;
  wagerBalanceUsd: number;
  inventoryPriceUsd: number;
  needPlayGames: number;
  isTosRead: boolean;
  steamAccount: SteamAccount|null;
  telegramAccount: TelegramAccount|null;
  vkAccount: VkAccount|null;
  wager: Wager|null;
};

export type SteamAccount = {
  id: string;
  steamId32: string;
  tradeToken: string|null;
};

export type Wager = {
  id: number;
  type: WagerType;
  bonusUsd: string;
  wageredAmountUsd: string;
  wagerAmountUsd: string;
  expiresAt: string|null;
};

export enum WagerType {
  PROMOCODE = 1,
	DEPOSIT = 2,
	SECRET_CODE_DEPOSIT = 3,
  SERVICE_ITEM = 4
}

export type TelegramAccount = {
  firstName: string;
  photoUrl: string;
  username: string;
  subscribedToChannel: boolean;
  hasClaimedBonus: boolean;
};

export type VkAccount = {
  photoBig: string;
  firstName: string;
  lastName: string;
  subscribedToChannel: boolean;
  hasClaimedBonus: boolean;
};

export enum UserRole {
  ROLE_SUPERADMIN = 'ROLE_SUPERADMIN',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MODER = 'ROLE_MODER',
  ROLE_HELPER = 'ROLE_HELPER',
  ROLE_ANALYTICS = 'ROLE_ANALYTICS',
  ROLE_ADV_MANAGER = 'ROLE_ADV_MANAGER',
  ROLE_SMM = 'ROLE_SMM',
  ROLE_YOUTUBER = 'ROLE_YOUTUBER',
  ROLE_TWITCH = 'ROLE_TWITCH',
  ROLE_USER = 'ROLE_USER'
}

export const DEFAULT_ROLE: string = UserRole.ROLE_USER;

export const ROLE_NAME: Record<string, string> = {
  'ROLE_SUPERADMIN': $localize`:@@users.roles.superadmin:Администратор`,
  'ROLE_ADMIN': $localize`:@@users.roles.admin:Администратор`,
  'ROLE_MODER': $localize`:@@users.roles.moder:Модератор`,
  'ROLE_YOUTUBER': $localize`:@@users.roles.youtuber:Ютубер`,
  'ROLE_TWITCH': $localize`:@@users.roles.twitch:Стример`
};

export const STAFF_ROLES: string[] = [
  'ROLE_MODER',
  'ROLE_ADMIN',
  'ROLE_SUPERADMIN',
  'ROLE_HELPER',
  'ROLE_SHERIFF'
];

export type Restriction = {
  type: RestrictionType;
  context: any;
  isPerm: boolean;
  autoremoveAt: string;
};

export const enum RestrictionType {
  ABUSER = 1,
  CHAT = 2,
  BAN = 3,
  SHADOW_BAN = 4,
  BONUS = 5,
  REFERRAL = 6,
  REFERRAL_CODE = 7,
  CRASH = 8,
  WHEEL = 9,
  JACKPOT = 10
}

export type ProfileStats = {
  gamesCount: number;
  gamesWon: number;
  moneyWonUsd: number;
  winrate: number;
  biggestCrashRatio: number;
  biggestWinUsd: number;
};

export type ProfileWebPushesStatus = {
  publicKey: string;
  subscription: SubscribedUser|null;
};

export type Counters = Record<GameMode, CounterValue|undefined>;

export type FooterCounters = {
  usersCount: number;
  gamesCount: number;
  usersWonAmount: string;
};

export type CounterValue = {
  bank: number;
  count: number
};

export type TelegramBotData = {
  initDataRaw: string | null;
  username: string | null;
  isCameFromBot: boolean;
}

export enum SideType {
  TERRORIST = 1,
  COUNTER_TERRORIST = 2
}

export namespace ApiResponse {
  export interface GetStatus {
    user: LoggedUser|null;
    serverTime: string;
    countryCode: string;
    intercomToken: string|null;
    counters: Counters;
    notifications: {
      unread: number;
      important: number;
    };
    footerCounters: FooterCounters;
    referralBlocked?: boolean;
  }

  export interface RedirectUrl {
    redirect: string;
  }
  
  // TODO move this interface to profile
  export interface Profile {
    user: User;
    leaderPlace: number;
    stats: ProfileStats;
    webPushes?: ProfileWebPushesStatus;
    dailyRewardsCurrentPrize?: any; // import { Reward } from '../daily-rewards/daily-rewards.entity';
    canResetNeedPlayGames?: boolean;
  }

  export interface SuccessAuthentication {
    token: string;
  }
}

export const TELEGRAM_HEADERS = 'telegram_data';